export default {
  name: 'tw-loader',
  props: {
    width: {
      type: [String, Number],
      default: 3.8095238095238093,
    }
  }
}
